import { computed, Injectable, signal } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import { fetchAuthSession } from '@aws-amplify/auth';
import { environment } from '../../../environments/environment';
import { Roles } from './roles';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {

  private readonly roles = signal<ReadonlyArray<string>>([]);

  public readonly isCPAdmin = computed(() =>
    this.roles().includes(Roles.CLOUDPORTAL_ADMIN) || this.roles().includes(Roles.AUTOFORM_ADMIN)
  );

  public readonly isAutoFormAdmin = computed(() =>
    this.roles().includes(Roles.AUTOFORM_ADMIN)
  );

  public readonly isCusMan = computed(() =>
    this.roles().includes(Roles.CUSTOMER_MANAGER)
  );

  public updateRoles(): Observable<void> {
    return from(fetchAuthSession()).pipe(
      map((v) => {
        const roles = v.tokens?.idToken?.payload[environment.roleField]?.toString();
        this.roles.set(
          roles
            ? roles.split(',').map((r) => r.trim()).filter((r) => r.length > 0)
            : []
        );
      })
    );
  }
}
